<template>
  <section>
    <v-container grid-list-xl>
      <v-layout row wrap>
        <v-flex lg12 sm12 xs12>
          <v-card outlined class="app-card">
            <v-card-title class="app-card-title" style="justify-content: center"
              >Tipo de Solicitação</v-card-title
            >
            <div style="text-align: center">
              <v-form ref="form" lazy-validation class="app-form">
                <v-col
                  :md="12"
                  :sm="12"
                  :xs="12"
                  cols="12"
                  style="justify-content: space-between"
                >
                  <v-btn
                    v-for="(value, index) in  dadosForm.dadosParaSolicitacao.listTipoSolicitacao"
                    style="margin-left: 4px; justify-content: space-between"
                    color="primary"
                    :key="index"
                    @click="buttonClicked(value.id)"
                    depressed
                  >
                    {{ value.descricao }}
                  </v-btn>
                </v-col>
              </v-form>
            </div>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>
<script>
import { mapActions, mapState } from "vuex";
const actions = mapActions("siePedidos", [
  "setTipoSolicitacao",
  "setDadosParaSolicitacao",
  "setFormStep",
]);
const state = mapState("siePedidos", ["dadosForm"]);

export default {
  name: "TipoSolicitacao",
  data: () => ({
    tipoSolicitacao: [],
  }),
  computed: {
    ...state,
  },
  methods: {
    ...actions,
    buttonClicked(value) {
      if (value) {
        this.setTipoSolicitacao(value);
        this.setFormStep(2);
      }
    }
  }
};
</script>
